export class GmwSecurityQuestions {
    constructor(HoldingApi) {
        this.HoldingApi = HoldingApi;
    }
    getSecurityQuestions() {
        const questionsPromise = this.HoldingApi.get('security/questions');
        return questionsPromise.then(questions => questions.map(question => ({
            value: question.id,
            label: question.value,
        })));
    }
    skip() {
        return this.HoldingApi.post('security/questions/skip');
    }
    submitAnswers(qa) {
        return this.HoldingApi.post('security/questions', { qa });
    }
}
GmwSecurityQuestions.$inject = [
    'HoldingApi',
];
angular
    .module('app.holding.dashboard.onboarding')
    .service('GmwSecurityQuestions', GmwSecurityQuestions);



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/onboarding/services/security-questions.ts